import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ZoomIn = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20.125 20.125L16.2515 16.2515M16.2515 16.2515C17.5635 14.9395 18.375 13.127 18.375 11.125C18.375 7.12094 15.1291 3.875 11.125 3.875C7.12094 3.875 3.875 7.12094 3.875 11.125C3.875 15.1291 7.12094 18.375 11.125 18.375C13.127 18.375 14.9395 17.5635 16.2515 16.2515ZM11.125 7.875V14.375M14.375 11.125L7.875 11.125'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.12476 11.1246C3.12476 6.70636 6.70648 3.12463 11.1248 3.12463C15.543 3.12463 19.1248 6.70636 19.1248 11.1246C19.1248 13.0634 18.4343 14.842 17.2872 16.2264L20.6555 19.5947C20.9484 19.8876 20.9484 20.3625 20.6555 20.6554C20.3626 20.9483 19.8877 20.9483 19.5948 20.6554L16.2265 17.287C14.8421 18.4342 13.0635 19.1246 11.1248 19.1246C6.70648 19.1246 3.12476 15.5429 3.12476 11.1246ZM11.8748 7.87463C11.8748 7.46042 11.539 7.12463 11.1248 7.12463C10.7105 7.12463 10.3748 7.46042 10.3748 7.87463V10.3746H7.87476C7.46054 10.3746 7.12476 10.7104 7.12476 11.1246C7.12476 11.5388 7.46054 11.8746 7.87476 11.8746H10.3748V14.3746C10.3748 14.7888 10.7105 15.1246 11.1248 15.1246C11.539 15.1246 11.8748 14.7888 11.8748 14.3746V11.8746H14.3748C14.789 11.8746 15.1248 11.5388 15.1248 11.1246C15.1248 10.7104 14.789 10.3746 14.3748 10.3746H11.8748V7.87463Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
